import React from 'react';
import { Trophy, Copy, Check } from 'lucide-react';
import { useState } from 'react';

const SuccessView = ({ betData, onBackToRules }) => {
  const [copied, setCopied] = useState(false);
  const promoCode = 'DS4FUN';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(promoCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = promoCode;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (fallbackErr) {
        console.error('Failed to copy:', fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: 'linear-gradient(135deg, #0A0512 0%, #11081A 100%)' }}>
      <div className="w-full max-w-2xl">
        <div className="glass-card p-8 md:p-12 fade-in">
          {/* Success Icon */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-[#8E24F5] to-[#A64DF7] mb-6 purple-glow">
              <Trophy className="w-10 h-10 text-white" />
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-3">
              Bets Locked In!
            </h2>
            <p className="text-[#A19EB5] leading-relaxed">
              Your predictions have been recorded. Good luck!
            </p>
          </div>

          {/* Bet Summary */}
          <div className="space-y-4 mb-8">
            <div className="border-l-4 border-[#A64DF7] pl-4 py-2 bg-[#8E24F5]/5 rounded-r-lg">
              <div className="text-xs uppercase tracking-[0.2em] text-[#A64DF7] mb-1 font-semibold">
                Bet #1 • April Launch
              </div>
              <div className="flex justify-between items-center">
                <span className="text-white">Prediction: <strong className="uppercase">{betData.bet1_choice}</strong></span>
                <span className="font-bold text-[#A64DF7]">${betData.bet1_wager}</span>
              </div>
            </div>

            <div className="border-l-4 border-[#A64DF7] pl-4 py-2 bg-[#8E24F5]/5 rounded-r-lg">
              <div className="text-xs uppercase tracking-[0.2em] text-[#A64DF7] mb-1 font-semibold">
                Bet #2 • SWE Bench 90%+
              </div>
              <div className="flex justify-between items-center">
                <span className="text-white">Prediction: <strong className="uppercase">{betData.bet2_choice}</strong></span>
                <span className="font-bold text-[#A64DF7]">${betData.bet2_wager}</span>
              </div>
            </div>

            <div className="border-l-4 border-[#A64DF7] pl-4 py-2 bg-[#8E24F5]/5 rounded-r-lg">
              <div className="text-xs uppercase tracking-[0.2em] text-[#A64DF7] mb-1 font-semibold">
                Bet #3 • Release Date
              </div>
              <div className="flex justify-between items-center">
                <span className="text-white">
                  {betData.bet3_date === 'after-30' ? 'After 30 days' : new Date(betData.bet3_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
                <span className="font-bold text-[#A64DF7]">${betData.bet3_wager}</span>
              </div>
            </div>

            <div className="border-t border-white/10 pt-4 mt-4">
              <div className="flex justify-between items-center text-lg">
                <span className="uppercase text-[#A64DF7] font-bold tracking-wider">Total Wagered</span>
                <span className="font-bold text-3xl">${betData.total_wager}</span>
              </div>
            </div>
          </div>

          {/* Promo Code */}
          <div className="border-2 border-[#8E24F5] p-6 mb-8 rounded-xl purple-glow">
            <div className="text-center mb-4">
              <div className="text-xs uppercase tracking-[0.2em] text-[#A64DF7] mb-2 font-semibold">
                Your Fireworks Credit Code
              </div>
              <div className="text-4xl font-black tracking-wider mb-2 text-gradient">{promoCode}</div>
              <div className="text-[#A19EB5] text-sm mb-3">Worth $4 in Fireworks credits</div>
              <a 
                href="https://www.loom.com/share/db284cad0fb44d67a1b80358ef049897"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#8E24F5] hover:text-[#A64DF7] text-sm underline transition-colors"
              >
                Watch: How to redeem your code
              </a>
            </div>
            <button
              data-testid="copy-code-button"
              onClick={handleCopy}
              className="purple-btn-outline w-full flex items-center justify-center gap-2"
            >
              {copied ? (
                <>
                  <Check className="w-4 h-4" />
                  Copied!
                </>
              ) : (
                <>
                  <Copy className="w-4 h-4" />
                  Copy Code
                </>
              )}
            </button>
          </div>

          {/* What's Next */}
          <div className="text-center">
            <h3 className="text-xl font-bold mb-3">What's Next?</h3>
            <ul className="text-left space-y-2 text-[#A19EB5] mb-6">
              <li className="flex items-start gap-2">
                <span className="text-[#A64DF7] mt-1">•</span>
                <span>Bets lock Monday morning - you can edit until then</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#A64DF7] mt-1">•</span>
                <span>Results announced after DeepSeek 4 release</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#A64DF7] mt-1">•</span>
                <span>Redeem your <strong className="text-white">$4 credit code</strong> at fireworks.ai</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#A64DF7] mt-1">•</span>
                <span>Winners will receive additional credits</span>
              </li>
            </ul>

            <button
              data-testid="back-to-home-button"
              onClick={onBackToRules}
              className="purple-btn-outline"
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessView;
